import { FormlyTemplateOptions } from '@ngx-formly/core';

export interface ISnPlacesAutocompleteTemplateOptions extends FormlyTemplateOptions {
  placesAutocompleteOptions?: google.maps.places.AutocompleteOptions;
  autocompleteOn?: boolean;
}
